import image from "./../assets/welcome.svg";

const welcome = {
  image: image,
};

export default welcome;
